import Vue from 'vue';
import ElementUI from 'element-ui';
import '@/assets/scss/index.scss';

import App from '@/views/app.vue';

import store from '@/store';
import router from '@/router';
import i18n from './lang'; // Internationalization
import '@/icons'; // icon

import Cookies from 'js-cookie';

import '@/permission'; // permission control
import AFTableColumn from 'af-table-column';
import * as filters from './filters'; // global filters
// 注册滚动条加载触发事件v-loadmore绑定
import * as directives from './directives';
import horizontalScroll from 'el-table-horizontal-scroll';
import '@/utils/polyfill';

import VueEasyTree from '@wchbrad/vue-easy-tree';
import '@wchbrad/vue-easy-tree/src/assets/index.scss';

import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

Vue.config.productionTip = false;
Vue.use(horizontalScroll);
Vue.use(directives);
Vue.use(AFTableColumn);
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
});

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
});

Vue.use(VueEasyTree);

Vue.use(VueVirtualScroller);

if (process.env.NODE_ENV === 'development') {
  // require('@/mock');
}

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  VisualMapComponent,
  DataZoomComponent,
  LegendComponent,
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LabelLayout,
  UniversalTransition,
  BarChart,
  LineChart,
  CanvasRenderer,
  VisualMapComponent,
  DataZoomComponent,
  LegendComponent,
]);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
